// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OnBoarding-Container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 134px);
}
.ProcessComplete-PopUp-Container{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.inputDivStyle-onboarding {
  width: 368px;
}

.SkipContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.skip-item {
  color: #148dfd;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 112.5% */
  cursor: pointer;
}

.main-onboarding-container {
  width: 100%;
  height: 100vh;
}
.css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed {
  color: #118dfd !important;
}
.stepperMainDiv {
  width: 100%;
  margin: 2% auto auto auto;
}
.customer__logo {
  margin-bottom: 8px;
}

.Team_Li {
  display: flex;
  list-style-type: none;
  padding: 8px 0px;
}

.UserMain {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 8px;
  margin-top: 5px;
}

.UserName {
  display: flex;
  flex-direction: column;
}

.User_name01 {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.Waiting_class {
  color: #556575;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}
.customer_label {
  margin-bottom: 12px;
}

.btn__back {
  background-color: #fff;
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
@media screen and (max-width: 550px) {
  .textDiv {
    color: #5f44f7;
    margin: 0px 0px 0px 0px;
    font-size: 22px;
    margin-bottom: 25px;
  }
  .inputDivStyle-onboarding {
    width: 100%;
    padding: 24px;
  }
  .footer__trust {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #777777;
    border: none;
    outline: none;
    padding: 10px 5px;
  }
}
.onboarding-illustration {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 38px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/OnBoarding/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".OnBoarding-Container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #fff;\n  min-height: calc(100vh - 134px);\n}\n.ProcessComplete-PopUp-Container{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.inputDivStyle-onboarding {\n  width: 368px;\n}\n\n.SkipContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.skip-item {\n  color: #148dfd;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 112.5% */\n  cursor: pointer;\n}\n\n.main-onboarding-container {\n  width: 100%;\n  height: 100vh;\n}\n.css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed {\n  color: #118dfd !important;\n}\n.stepperMainDiv {\n  width: 100%;\n  margin: 2% auto auto auto;\n}\n.customer__logo {\n  margin-bottom: 8px;\n}\n\n.Team_Li {\n  display: flex;\n  list-style-type: none;\n  padding: 8px 0px;\n}\n\n.UserMain {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin-left: 8px;\n  margin-top: 5px;\n}\n\n.UserName {\n  display: flex;\n  flex-direction: column;\n}\n\n.User_name01 {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.Waiting_class {\n  color: #556575;\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 150% */\n}\n.customer_label {\n  margin-bottom: 12px;\n}\n\n.btn__back {\n  background-color: #fff;\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n@media screen and (max-width: 550px) {\n  .textDiv {\n    color: #5f44f7;\n    margin: 0px 0px 0px 0px;\n    font-size: 22px;\n    margin-bottom: 25px;\n  }\n  .inputDivStyle-onboarding {\n    width: 100%;\n    padding: 24px;\n  }\n  .footer__trust {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: #777777;\n    border: none;\n    outline: none;\n    padding: 10px 5px;\n  }\n}\n.onboarding-illustration {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 38px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
